export default {"src":"/login-app/[GIT_HASH]/_next/static/media/reload-definitions.a30a45dd.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};